import React, { useState, useEffect, useContext } from 'react';
import { Box } from '@material-ui/core';
import { useRouteMatch } from 'react-router';
import PropTypes from 'prop-types';

import { WebContext } from 'src/scenes/web-context';
import { MonitoringPlanDrawer } from 'src/components';
import { useMonitoringPlanApi, useProjectApi } from 'src/services';
import { MonitoringPlanRoutes } from 'src/scenes/Project/scenes/MonitoringPlan/MonitoringPlanRoutes';


const MonitoringPlanContainer = ({ project }) => {
  const [ monitoringPlanName, setMonitoringPlanName ] = useState('');
  const { currentUser: { roleId: userRoleId } } = useContext(WebContext);
  const match = useRouteMatch();
  const monitoringPlanApi = useMonitoringPlanApi();
  const projectApi = useProjectApi();

  let { monitoringPlanId, projectId, siteId } = match.params;
  projectId = siteId ? siteId : projectId;

  useEffect(() => {
    const fetchData = async () => {
      const [ monitoringPlan ] = await Promise.all([
        monitoringPlanApi.getMonitoringPlans({ monitoringPlanId }),
        projectApi.getProject(projectId),
      ]);
      const { monitoringPlanList: [ { name: monitoringPlanName } ] } = monitoringPlan;
      setMonitoringPlanName(monitoringPlanName);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ monitoringPlanId ]);

  useEffect(() => {
    document.title = monitoringPlanName ? `${monitoringPlanName} - Nviro Monitor` : 'Nviro Monitor';
  }, [ monitoringPlanName ]);

  return (
    <>
      <MonitoringPlanDrawer name={monitoringPlanName} project={project} userRoleId={userRoleId} />
      <Box pb={5}>
        <MonitoringPlanRoutes name={monitoringPlanName} project={project} userRoleId={userRoleId} />
      </Box>
    </>
  );
};

MonitoringPlanContainer.propTypes = {
  project: PropTypes.shape({
    siteName: PropTypes.string,
    siteId: PropTypes.number,
    name: PropTypes.string,
    id: PropTypes.number,
  }),
};

export { MonitoringPlanContainer };
